<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <!-- breadcrumb and title row starts -->
                <div class="row">
                    <div class="col-sm-12 print-scr">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },

                  {
                    title: 'Agenda Report',
                    active: true
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Agenda Report</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <!-- report row starts  -->
                <div class="row">
                    <div class="col-sm-12">
                        <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
                            <i class="material-icons">print</i> Print
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <!-- form starts  -->
                        <form style="border: 1px solid #06a6e0;padding: 20px 10px;">
                            <!-- form row 1 starts -->
                            <div class="form-group row">
                                <!-- col Number of Days starts -->
                                <div class="col-sm-2 mrgn-bot">
                                    <label style="color:#6c757d;" for="formGroupExampleInput">
                                        <b>Number of Days</b>
                                    </label>
                                    <input style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;" type="text" readonly class="form-control" id="disabledTextInput" value="5" />
                                </div>
                                <!-- col Number of Days Ends -->
                                <!-- --------------------------- -->
                                <!-- col Number of Session starts -->
                                <div class="col-sm-2 mrgn-bot">
                                    <label style="color:#6c757d;" for="formGroupExampleInput">
                                        <b>Number of Session</b>
                                    </label>
                                    <input style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;" type="text" readonly class="form-control" id="disabledTextInput" value="2" />
                                </div>
                                <!-- col Number of Session Ends -->
                                <!-- --------------------------- -->
                                <!-- col Title starts -->
                                <div class="col-sm-8">
                                    <label style="color:#6c757d;" for="formGroupExampleInput">
                                        <b>Title</b>
                                    </label>
                                    <input style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;" type="text" readonly class="form-control" id="disabledTextInput" value="Group Discussion Homicide (PPC, CrPC)" />
                                </div>
                                <!-- col Title Ends -->
                            </div>
                            <!-- form row 1 Ends -->
                            <!-- ---------------------------- -->
                            <!-- form row 2 starts -->
                            <div class="form-group row">
                                <!-- col Training Title starts -->
                                <div class="col-sm-7 mrgn-bot">
                                    <label style="color:#6c757d;" for="formGroupExampleInput">
                                        <b>Event Title</b>
                                    </label>
                                    <input style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;" type="text" readonly class="form-control" id="disabledTextInput" value="Advance Investigation In Terrorism Cases (Investigation Of Heinous Crimes) Week-2" />
                                </div>
                                <!-- col Training Title Ends -->
                                <!-- --------------------------- -->
                                <!-- col Assigned To starts -->
                                <div class="col-sm-3 mrgn-bot">
                                    <label style="color:#6c757d;" for="formGroupExampleInput">
                                        <b>Assigned To</b>
                                    </label>
                                    <input style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;" type="text" readonly class="form-control" id="disabledTextInput" value="Sikandar Sahibzad" />
                                </div>
                                <!-- col Assigned To Ends -->
                                <!-- --------------------------- -->

                                <!-- col Created on starts -->
                                <div class="col-sm-2">
                                    <label style="color:#6c757d;" for="formGroupExampleInput">
                                        <b>Created on</b>
                                    </label>
                                    <input style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;" type="text" readonly class="form-control" id="disabledTextInput" value="01/13/2020" />
                                </div>
                                <!-- col Created on Ends -->
                                <!-- --------------------------- -->
                            </div>
                            <!-- form row 2 Ends -->
                            <!-- ---------------------------- -->

                        </form>
                        <!-- form ends  -->
                    </div>
                </div>
                <!-- report row ends  -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
    data: () => ({
        isSidebar: false
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        printReport: function () {
            window.print();
        }
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    }
};
</script>

<style scoped>
@media print {
    .print-scr {
        display: none;
    }

    .print-btn {
        display: none;
    }

    .cont-bdr {
        display: block;
    }

    .heading {
        display: block;
    }
}

@media screen and (max-width: 600px) {
    .mrgn-bot {
        margin-bottom: 1rem !important;
    }
}
</style>
